module.exports = __webpack_public_path__ + "img/vast-ip.b4814656.svg";